// Utility functions shared across IndexDetailPage sub-components
// Single canonical source — extracted from IndexDetailPage.js

export const TIMEFRAMES = ["1D", "1W", "1M", "3M", "6M", "1Y", "3Y", "5Y", "All"];

export const fmt = (v) => v != null ? v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "--";

export const fmtCr = (v) => {
  if (!v) return "N/A";
  if (v >= 1e12) return `₹${(v / 1e12).toFixed(2)}L Cr`;
  if (v >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  return `₹${v.toLocaleString("en-IN")}`;
};

// Index logos for 5 main FnO indices (SVG data URIs — lightweight, no network request)
// NIFTY 50 = blue N50, SENSEX = red S, BANKNIFTY = green BN, MIDCPNIFTY = purple M, FINNIFTY = teal FN
const _svg = (text, bg) =>
  `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"><rect width="56" height="56" rx="28" fill="${bg}"/><text x="28" y="32" text-anchor="middle" fill="white" font-size="16" font-weight="700" font-family="system-ui,sans-serif">${text}</text></svg>`)}`;

export const INDEX_LOGOS = {
  "nifty": _svg("N50", "#1a56db"),
  "sensex": _svg("S", "#dc2626"),
  "banknifty": _svg("BN", "#059669"),
  "midcap-nifty": _svg("MC", "#7c3aed"),
  "fin-nifty": _svg("FN", "#0891b2"),
};

// "NIFTY 22900 Put" from {underlying:"NIFTY", strike:22900, type:"Put"}
export const formatOptionName = (indexShortName, strike, type) => {
  const s = typeof strike === 'number' ? strike.toLocaleString('en-IN') : strike;
  return `${indexShortName} ${s} ${type}`;
};

// Parse "NIFTY26MARFUT" → "NIFTY Mar 2026 Future"
const MONTH_MAP = { JAN:'Jan', FEB:'Feb', MAR:'Mar', APR:'Apr', MAY:'May', JUN:'Jun', JUL:'Jul', AUG:'Aug', SEP:'Sep', OCT:'Oct', NOV:'Nov', DEC:'Dec' };
export const formatFuturesName = (tradingsymbol, underlying) => {
  const base = underlying || '';
  const suffix = tradingsymbol.replace(base, '');
  const match = suffix.match(/^(\d{2})([A-Z]{3})FUT$/i);
  if (match) {
    const year = `20${match[1]}`;
    const month = MONTH_MAP[match[2].toUpperCase()] || match[2];
    return `${base} ${month} ${year} Future`;
  }
  return tradingsymbol;
};

// Format expiry date: "2026-03-30" → "30 Mar"
export const formatExpiry = (expiryStr) => {
  if (!expiryStr) return '';
  try {
    const d = new Date(expiryStr);
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return `${d.getDate()} ${months[d.getMonth()]}`;
  } catch { return expiryStr; }
};
